import React from 'react';
import { Box, Image } from '@chakra-ui/react';

interface EditButtonProps {
  onClick: () => void;
  borderColor?: string;
  borderWidth?: string;
  hoverBorderColor?: string;
  hoverBackgroundColor?: string;
  backgroundColor?: string;
  size?: string;
  iconWidth?: string;
  iconHeight?: string;
  iconSrc?: string;
  position?: 'absolute' | 'relative' | 'fixed' | 'sticky' | 'static';
  top?: string | number;
  right?: string | number;
  zIndex?: number;
}

const EditButton: React.FC<EditButtonProps> = ({
  onClick,
  borderColor = '#C6D959',
  borderWidth = '2px',
  hoverBorderColor = '#C6D959',
  hoverBackgroundColor = 'rgba(198, 217, 89, 0.1)',
  backgroundColor = 'rgba(28, 28, 30, 0.8)',
  size = '36px',
  iconWidth = '18',
  iconHeight = '18',
  iconSrc = '/assets/images/edit-icon.svg',
  position,
  top,
  right,
  zIndex
}) => {
  return (
    <Box
      position={position}
      top={top}
      right={right}
      width={size}
      height={size}
      border={`${borderWidth} solid ${borderColor}`}
      borderRadius="50%"
      backgroundColor={backgroundColor}
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      zIndex={zIndex}
      onClick={onClick}
      _hover={{
        borderColor: hoverBorderColor,
        backgroundColor: hoverBackgroundColor
      }}
    >
      <Image
        src={iconSrc}
        alt="Edit"
        width={iconWidth}
        height={iconHeight}
      />
    </Box>
  );
};

export default EditButton;

